export const CUSTOM_EXCEL_EXPORT_FLAG = "CUSTOM_EXCEL_EXPORT";

export const CUSTOM_EXCEL_EXPORT_ROUTE = "custom-excel-export";

export const openCustomExcelExport = (projectId: string): void => {
  window.open(`/project/${projectId}/${CUSTOM_EXCEL_EXPORT_ROUTE}`, "_blank");
};
